/**
 * Безопасные зоны экрана (M1, `docs/MOBILE_PARALLEL.md`).
 *
 * Зачем это вообще нужно. В браузере у страницы есть отступы, которые рисует
 * сам браузер (адресная строка, панель вкладок). В режиме «на домашнем экране»
 * (PWA) и в будущей нативной обёртке этих отступов нет: приложение занимает
 * весь экран, включая зону чёлки и полосу home-индикатора. Без учёта
 * `env(safe-area-inset-*)` шапка уезжает под системную плашку, а последняя
 * кнопка шторки — под полосу системы, и нажать её нельзя.
 *
 * Почему константы, а не классы в CSS. `env()` в CSS-файле работает так же
 * хорошо, но проверить его в тестах нельзя: vitest подменяет импорт стилей
 * пустой строкой. Здесь значения — обычные строки, поэтому страж видит их
 * (`pwa.test.ts`, «мобильная оболочка (M1)») и падает, если кто-то вычистит
 * отступы как «лишний шум в классе».
 *
 * Почему `0px` в `env()` вторым аргументом: старые браузеры без поддержки
 * `env()` оставили бы `padding: env(...)` невалидным, а фолбэк делает правило
 * безопасным — без зон просто нет отступов.
 */

/** Значение inset для конкретной стороны: «top», «bottom», «left», «right». */
function inset(side: "top" | "bottom" | "left" | "right"): string {
  return `env(safe-area-inset-${side}, 0px)`;
}

/**
 * Отступы корня приложения: верх и бока.
 *
 * Низ здесь намеренно не учтён — его добирает та поверхность, которая реально
 * доходит до края экрана (полоса вкладок или шторка). Иначе отступ посчитался
 * бы дважды и между контентом и полосой появилась бы пустая полоса.
 */
export const SAFE_AREA_ROOT = {
  paddingTop: inset("top"),
  paddingLeft: inset("left"),
  paddingRight: inset("right"),
} as const;

/** Низ экрана: для поверхностей, прижатых к нижнему краю. */
export const SAFE_AREA_BOTTOM = inset("bottom");

/** Верхняя кнопка поверх фото: 12 px плюс сама зона. */
export const SAFE_AREA_TOP_OFFSET = `calc(0.75rem + ${inset("top")})`;
